import { useQuery } from 'urql';
import { streetPageQuery } from './streetPageQuery';
import { getSlugFromPathname } from '../../helpers/getSlugFromPathname';
import { useUrlContext } from '../../contexts/UrlContext/UrlContext';
import { useFeatureRollout } from '@rea-argonaut/experiment';

export const useStreetPageQuery = () => {
  const { pathname } = useUrlContext();

  const toggleMediaPartnerBannerTemporaryCampaign = useFeatureRollout(
    'media_partner_banner_temporary_campaign',
  ).isEnabled();

  const [result] = useQuery({
    query: streetPageQuery,
    variables: { slug: getSlugFromPathname(pathname), toggleMediaPartnerBannerTemporaryCampaign },
  });

  return result;
};
